/**
 * Niveaus API Client
 *
 * API functions for niveau (function level) management.
 */

import { apiRequest } from './api';

/**
 * Niveau with statistics
 */
export interface NiveauWithStats {
  id: number;
  name: string;
  beschrijving: string | null;
  criteria: string;
  minPunten: number | null;
  maxPunten: number | null;
  usesMarktcorrectie: boolean;
  marktcorrectiePercentage: number;
  employeesCount: number;
  tasksCount: number;
  createdAt: string;
  updatedAt: string;
}

/**
 * Update niveau input
 */
export interface UpdateNiveauInput {
  name?: string;
  beschrijving?: string | null;
  criteria?: string;
  minPunten?: number | null;
  maxPunten?: number | null;
  usesMarktcorrectie?: boolean;
  marktcorrectiePercentage?: number;
}

/**
 * Niveau summary response
 */
export interface NiveauSummary {
  totalEmployees: number;
  totalTasks: number;
  distribution: Array<{
    niveauId: number;
    niveauName: string;
    employees: number;
    tasks: number;
    employeesPercentage: number;
    tasksPercentage: number;
  }>;
}

/**
 * Niveaus API functions
 */
export const niveausApi = {
  /**
   * Get all niveaus with statistics
   */
  async getAll(): Promise<NiveauWithStats[]> {
    return apiRequest<NiveauWithStats[]>('/niveaus');
  },

  /**
   * Get niveau by ID with statistics
   */
  async getById(id: number): Promise<NiveauWithStats> {
    return apiRequest<NiveauWithStats>(`/niveaus/${id}`);
  },

  /**
   * Get niveau distribution summary
   */
  async getSummary(): Promise<NiveauSummary> {
    return apiRequest<NiveauSummary>('/niveaus/summary');
  },

  /**
   * Update a niveau
   */
  async update(id: number, input: UpdateNiveauInput): Promise<NiveauWithStats> {
    return apiRequest<NiveauWithStats>(`/niveaus/${id}`, {
      method: 'PUT',
      body: JSON.stringify(input),
    });
  },
};
